/* import __COLOCATED_TEMPLATE__ from './sq-field-input-money.hbs.js'; */
// `SqFieldInputMoneyComponent` is a variation on sq-input-money, a text field input with localized formatting
// for money. It creates a money object that includes a currency code and an integer value. For string values,
// use SqFieldInputCurrencyComponent Instead.
//
// Like other `SqFieldInput` components, the input is technically standalone, but is
// really intended to be nested inside a Form Field block component. The two components
// communicate with each other over event handling and auto fill in placeholder if you don't add one.
//
// Parameters to the component can follow any standard Ember Input helper. Not really anything proprietary or new here.
//
// Sass dependencies at:
// `app/assets/stylesheets/bridgeport/components/form-elements/formfield/_formfield.sass`
//
// ## Example
//
// {{sq-field-input-money fieldName=name}}

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import FieldElementSupport from '@square/glass-ui/utils/field-element-support';
import SqInputMoneyComponent from '@dashboard/shared-ui/components/sq-input-money';
export default class SqFieldInputMoney extends SqInputMoneyComponent.extend(FieldElementSupport) {
  // sq-input-formattted uses the "field-kit" library to override the behavior of a normal input field.
  // It sets this component as a delegate to receive events including `textDidChange` which represents user input events
  // before the formatting and value update has taken place.
  // Normally we would observe the `input` element's `input` event, but that is not being exposed to us.
  textDidChange(...args) {
    if (this.onTextDidChange) {
      this.onTextDidChange(...args);
    }
  }
}